module.exports = __webpack_public_path__ + "img/edge_activites_parapente.f8d64678.svg";